module.exports = __webpack_public_path__ + "img/ios_model_300.fb9c16bb.jpg";